import { useEffect, useState } from "react";
import Checkbox from "./Checkbox";

export default function SelectItem({ account, children, rowAlign }) {
  const [checked, setIsChecked] = useState();

  useEffect(() => {
    account.isSelected = checked;
  }, [checked]);

  return (
    <li className="select-item" id={account?.customerNumber}>
      <div className="select-item-container">
        <div className={`select-item-wrapper--${rowAlign}`}>
          {children}
          <div className="select-item-info-container">
            <div className="select-item-account-info">
              <p className="select-item-text">{account.customerName}</p>
              <small className="select-item-text-small">
                {account?.customerAddress}
                {account?.address1}
                {account?.address2}
                {account?.cityStateZip}
              </small>
            </div>
            <div className="select-item-actual">
              <div className="checkbox-container">
                <Checkbox isChecked={checked} setIsChecked={setIsChecked} />
              </div>
              <label className="select-item-actual-text">Select</label>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
